import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}



export default function BasicTable(props) {
    const rows = props.data;
    const Class_ = props.Class_ || [];
    const chosen = props.chosen;
    const schooldata = Array.isArray(props.schooldata) ? props.schooldata : [];
    console.log(rows);


    const remarks = (data) => {

        if (data === "Excellent" || data === "Distinction") {
            return (<span style={{ color: "darkgreen" }}>{data}</span>)

        }
        else if (data === "Very Good") {
            return (<span style={{ color: "darkblue" }}>{data}</span>)

        }
        else if (data === "Good" || data === "High Average") {
            return (<span style={{ color: "Black" }}>{data}</span>)

        }
        else if (data === "Credit" || data === "Avereage") {
            return (<span style={{ color: "grey" }}>{data}</span>)

        }
        else if (data === "Pass" || data === "Low Avereage") {
            return (<span style={{ color: "gray" }}>{data}</span>)

        }
        else {
            return (<span style={{ color: "red" }}>{data}</span>)

        }
    }

    // Get class subjects to identify special exams
    const classEntry = Class_.length > 0 && chosen 
        ? Class_.find(bug => bug.classname === chosen.class_) || Class_[0]
        : null;
    
    // Handle nested array structure for subjects
    let classSubjects = [];
    if (classEntry && Array.isArray(classEntry.subjects)) {
        if (classEntry.subjects.length > 0 && Array.isArray(classEntry.subjects[0])) {
            classSubjects = classEntry.subjects[0];
        } else {
            classSubjects = classEntry.subjects;
        }
    }

    // Build subject type map
    const subjectTypeMap = {};
    classSubjects.forEach((subj) => {
        if (subj && subj.subject !== undefined && subj.subject !== null) {
            const key = String(subj.subject).trim();
            const type = (subj.type || '').trim();
            subjectTypeMap[key] = type;
            
            if (subj.subjectName && String(subj.subjectName).trim() !== key) {
                subjectTypeMap[String(subj.subjectName).trim()] = type;
            }
        }
    });

    // Active grading scale: class first, fallback to school
    const activeGrades = (Array.isArray(classEntry?.grades) && classEntry.grades.length > 0)
        ? classEntry.grades
        : (Array.isArray(schooldata?.[0]?.grades) ? schooldata[0].grades : []);

    const resolveRemarkFromScale = (score100) => {
        const score = parseFloat(score100);
        if (Number.isNaN(score) || !Array.isArray(activeGrades) || activeGrades.length === 0) return "";
        const match = activeGrades.find((g) => {
            const upper = parseFloat(g?.upperlimit);
            const lower = parseFloat(g?.lowerlimit);
            if (Number.isNaN(upper) || Number.isNaN(lower)) return false;
            const max = Math.max(upper, lower);
            const min = Math.min(upper, lower);
            return score <= max && score >= min;
        });
        return match?.remarks || match?.remark || "";
    };

    const parseSpecialToPercent = (specialExamScore) => {
        if (specialExamScore === null || specialExamScore === undefined) return null;
        const raw = String(specialExamScore).trim();
        // obtained/total
        if (raw.includes("/")) {
            const parts = raw.split("/");
            if (parts.length !== 2) return null;
            const obtained = parseFloat(parts[0]);
            const total = parseFloat(parts[1]);
            if (Number.isNaN(obtained) || Number.isNaN(total) || total <= 0) return null;
            return (obtained / total) * 100;
        }
        // plain percent (e.g., "0.00", "75")
        const num = parseFloat(raw);
        if (!Number.isNaN(num)) return num;
        return null;
    };

    const getSpecialExamRemark = (row) => {
        const specialScoreRaw = row.specialExamScore ?? row.score ?? "";
        const percent = parseSpecialToPercent(String(specialScoreRaw));
        const generated = percent !== null ? resolveRemarkFromScale(percent) : "";
        return generated
            || row.specialExamRemark
            || row.specialRemarks
            || row.specialRemark
            || row.remarks
            || row.remark
            || "";
    };

    // Separate regular subjects and special exams
    const regularSubjects = [];
    const specialExamSubjects = [];
    
    if (rows.length !== 0 && rows[0].results) {
        rows[0].results.forEach((row) => {
            const subjectName = String(row.subject || '').trim();
            const rawType = subjectTypeMap[subjectName] || '';
            const typeLower = rawType.toLowerCase().trim();
            
            // Check if it's a special exam by type OR if it has specialExamScore
            if (typeLower === 'special exams' || typeLower === 'special exam' || row.specialExamScore) {
                specialExamSubjects.push(row);
            } else {
                regularSubjects.push(row);
            }
        });
    }

    return (
        <>
        <TableContainer >
            <br />
            <Divider />
            <Table sx={{ minWidth: "100%", }} aria-label="simple table">
                <TableHead >
                    <TableRow>
                        <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>SUBJECT</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>CLASS SCORE (50%)</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>EXAM SCORE (50%)</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>TOTAL (100%)</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>GRADE</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>REMARKS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                    {regularSubjects.map((row) => (
                        <TableRow
                            key={row.subject}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell style={{padding:2, margin:2}} component="th" scope="row">
                                {(row.subject).toUpperCase()}
                            </TableCell>
                            <TableCell  style={{padding:2, margin:2}} align="left">{row.class_scorre}</TableCell>
                            <TableCell  style={{padding:2, margin:2}} align="left">{row.exam_score}</TableCell>
                            <TableCell  style={{padding:2, margin:2}} align="left">{row.total}</TableCell>
                            <TableCell  style={{padding:2, margin:2}} align="left">{row.grade}</TableCell>
                            <TableCell  style={{padding:2, margin:2,  fontWeight: "bolder"}} align="left" >  {remarks(row.remarks)}  </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

        {/* Special Exams Section */}
        {specialExamSubjects.length > 0 && (
            <>
                <br />
                <Divider />
                <div style={{textAlign:"center", marginTop:"15px", marginBottom:"10px"}}>
                    <h4 style={{color:"#1976d2", fontWeight:"bold", margin:0}}>SPECIAL EXAMS</h4>
                    <p style={{fontSize:"11px", color:"#666", fontStyle:"italic", margin:"5px 0"}}>
                        Note: These scores are not added to the main academic scores.
                    </p>
                </div>
                <TableContainer>
                    <Table sx={{ minWidth: "100%", }} aria-label="special exams table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>SUBJECT</TableCell>
                                <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>SCORE</TableCell>
                                <TableCell align="left" style={{ fontWeight: "bolder",padding:2, margin:2 }}>REMARKS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {specialExamSubjects.map((row) => (
                                <TableRow
                                    key={row.subject}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell style={{padding:2, margin:2}} component="th" scope="row">
                                        {String(row.subject || row.subjectName || '').toUpperCase()}
                                    </TableCell>
                                    <TableCell style={{padding:2, margin:2}} align="left">
                                        {row.specialExamScore ?? row.score ?? '-'}
                                    </TableCell>
                                    <TableCell style={{padding:2, margin:2, fontWeight: "bolder"}} align="left">
                                        {remarks(getSpecialExamRemark(row))}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        )}
        </>
    );
}
